import type { MultiWatchSources } from 'vue'

export function usePublicInformation(
  id: MaybeRefOrGetter<string>,
  options?: { immediate?: boolean; watch: MultiWatchSources }
) {
  const { isDirectSign } = storeToRefs(useDirectSignStore())
  const { businessRepository, directBusinessRepository } = useLegacyApi()

  const key = computed(() => `publicBusinessInfo:${toValue(id)}`)

  return useAsyncData(
    key,
    async () => {
      const businessId = toValue(id)

      if (!businessId) return null

      return isDirectSign.value
        ? directBusinessRepository.getPublicInfo(businessId)
        : businessRepository.getPublicInfo(businessId)
    },
    {
      lazy: true,
      dedupe: 'defer',
      ...options,
    }
  )
}
